<template>
    <div class="nc-msg-text" :class="isOperator ? 'nc-msg-text_operator' : isAI ? 'nc-msg-text_ai' : 'nc-msg-text_customer'">
        <div class="nc-msg-text__bubble">
            <div class="nc-msg-text__header" v-if="!isOperator && message.client_info && message.client_info.name">
                <span class="nc-msg-text__name">{{ message.client_info.name }}</span>
            </div>
            <p class="nc-msg-text__body">{{ message.message }}</p>
            <div class="nc-msg-text__footer">
                <div v-if="message.platform" class="nc-msg-text__platform">
                    <new-chat-platform-icon :supplier-id="message.platform.supplier_id" />
                    <span class="nc-msg-text__platform-name">{{ message.platform.name }}</span>
                </div>
                <span class="nc-msg-text__time">{{ formattedTime }}</span>
                <span v-if="isOperator" class="nc-msg-text__status" :class="statusClass">
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import NewChatPlatformIcon from '../../shared/NewChatPlatformIcon.vue'

export default {
    name: 'NewChatMessageText',
    components: { NewChatPlatformIcon },
    props: {
        message: {
            type: Object,
            required: true,
        },
    },
    computed: {
        isOperator() {
            return this.message.sender_id === 'operator'
        },
        isAI() {
            return this.message.sender_id === 'ai'
        },
        formattedTime() {
            return this.message.date_created || ''
        },
        statusClass() {
            return {
                'nc-msg-text__status_failed':  this.message.send_status === 'failed',
                'nc-msg-text__status_sending': this.message.send_status === 'sending',
            }
        },
    },
}
</script>

<style lang="scss">
@import '../../../../../../gulp-src/app/scss/_variables';

.nc-msg-text {
    display: flex;
    margin-bottom: 6px;

    &_operator {
        justify-content: flex-end;

        .nc-msg-text__bubble {
            background-color: $global-dark-3a;
            color: $global-white;
            border-radius: 12px 12px 2px 12px;
        }

        .nc-msg-text__time {
            color: rgba(255, 255, 255, 0.6);
        }
    }

    &_ai {
        justify-content: flex-end;

        .nc-msg-text__bubble {
            background-color: #6362e5;
            color: $global-white;
            border-radius: 12px 12px 2px 12px;
        }

        .nc-msg-text__time {
            color: rgba(255, 255, 255, 0.6);
        }
    }

    &_customer {
        justify-content: flex-start;

        .nc-msg-text__bubble {
            background-color: $global-white-f6;
            color: $global-black;
            border-radius: 12px 12px 12px 2px;
        }

        .nc-msg-text__time {
            color: $global-gray;
        }
    }

    &__bubble {
        max-width: 75%;
        padding: 8px 10px 6px;
    }

    &__header {
        margin-bottom: 2px;
    }

    &__name {
        font-size: 12px;
        font-weight: 600;
        color: $global-gray;
    }

    &__body {
        font-size: 14px;
        line-height: 20px;
        white-space: pre-wrap;
        word-break: break-word;
        margin: 0;
    }

    &__footer {
        display: flex;
       flex-direction: column;
        align-items: flex-start;
        flex:1;
        gap: 6px;
        margin-top: 4px;
        justify-content: flex-start;
      flex-wrap: wrap;
    }

    &__platform {
        display: flex;
        align-items: center;
        gap: 4px;
        flex: 0 0 auto;
    }

    &__platform-name {
        font-size: 11px;
        line-height: 14px;
        color: inherit;
        opacity: 0.6;
        white-space: nowrap;
    }

    &__sep {
        font-size: 11px;
        line-height: 14px;
        opacity: 0.4;
        flex: 0 0 auto;
    }

    &__time {
        font-size: 11px;
        line-height: 14px;
        margin-left: auto;
    }

    &__status {
        display: flex;
        align-items: center;
        color: rgba(255, 255, 255, 0.6);

        &_failed {
            color: #ff4d4f;
        }

        &_sending {
            opacity: 0.5;
        }

        svg {
            display: block;
        }
    }

    &__status-pending {
        font-size: 11px;
        letter-spacing: 1px;
        line-height: 1;
    }
}
</style>
